/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Topics_Not_DiscussedInputs */



/**
* | output |
* | --- |
* | "Not discussed" |
*
* @param {Meeting_Topics_Not_DiscussedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_topics_not_discussed = /** @type {((inputs?: Meeting_Topics_Not_DiscussedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Topics_Not_DiscussedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Niet besproken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non abordé")
	return /** @type {LocalizedString} */ ("Not discussed")
});